<template>
    <div class="loan-eligibility">
        <b-card no-body>
            <b-card-header class="border-0">
                <b-row align-v="center">
                    <b-col cols="12">
                        <h3 class="mb-0">
                            Loan Eligibility
                        </h3>
                    </b-col>
                    <!-- <b-col cols="6">
                        <el-button class="float-right text-muted py-0" type="text" disabled>View More</el-button>
                    </b-col> -->
                </b-row>
            </b-card-header>
            <div class="eligiblity-table">
                <el-table :data="tableData" empty-text="No Data" style="width: 100%" v-loading="is_loading_table">
                    <el-table-column prop="product" label="Product" min-width="130">
                        <template v-slot="{ row }">
                            <span class="text-truncate">{{ row.product }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="loan" label="Loan" min-width="110" width="auto">
                        <template v-slot="{ row }">
                            <span v-if="row.loan === 'N/A'">N/A</span>
                            <span v-else>RM{{ row.loan | moneyFormatter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="status" width="auto">
                        <template v-slot="{ row }">
                            <span class="text-success text-xs" v-if="row.status === 'Eligible'">Eligible</span>
                            <span class="text-danger text-xs" v-if="row.status === 'Not Eligible'">Not Eligible</span>
                            <span class="text-muted text-xs" v-if="row.status === 'N/A'">N/A</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <b-card-footer class="col-12 d-flex justify-content-center">
                <b-button @click="$refs.drawer_solution_scenario.viewSolutionScenario()" block variant="primary"
                    :disabled="is_loading_table">Select Product</b-button>
            </b-card-footer>
        </b-card>

        <!-- Drawer Solution Scenario -->
        <drawer-solution-scenario ref="drawer_solution_scenario"
            :product_details="tableData"></drawer-solution-scenario>
    </div>
</template>
<script>
import { Card, Button, Table, TableColumn } from 'element-ui'
import DrawerSolutionScenario from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/DrawerSolutionScenario'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useAuthStore } from '@/stores/authStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'

export default {
    name: 'loan-eligibility',
    components: {
        DrawerSolutionScenario,
        [Card.name]: Card,
        [Button.name]: Button,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            tableData: [
                {
                    product: 'Property',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Mortgage',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Personal Loan',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Insurance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Refinance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Other Loan',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Solicitor',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                }
            ],
            max_personal_loan_amount: 0,
            is_loading_table: true,
            max_amounts: [],
        }
    },
    async created() {
        this.is_loading_table = true // ensure loading is shown
        // make sure we have both eligibility responses so the watcher can run safely
        await Promise.all([this.getEligibilityPL(), this.getEligibility()]).catch(() => {
            // on error, stop loading to avoid infinite spinner
            this.is_loading_table = false
        })
        // build table in case both values were loaded immediately
        this.buildTableData()
    },
    computed: {
        ...mapState(useCustomerStore, ['current_eligibility', 'current_eligibility_pl']),
        ...mapState(useAuthStore, ['auth_user'])
    },
    watch: {
        current_eligibility(newVal) {
            if (newVal) {
                // update property/mortgage rows immediately
                this.updateBaseRows()
                if (this.current_eligibility_pl) {
                    this.buildTableData()
                }
            }
        },
        current_eligibility_pl(newVal) {
            if (newVal) {
                // when PL data arrives, recompute personal loan eligibility
                this.refreshPersonalLoan()
                if (this.current_eligibility) {
                    this.buildTableData()
                }
            }
        }
    },
    methods: {
        ...mapActions(useCustomerStore, ['getEligibilityPL','getEligibility']),
        updateBaseRows() {
            if (!this.current_eligibility) return;
            const val = parseFloat(this.current_eligibility.max_eligibility || 0)
            this.tableData.forEach(row => {
                if (row.product === 'Property' || row.product === 'Mortgage') {
                    row.loan = val
                    row.status = val > 0 ? 'Eligible' : 'Not Eligible'
                }
            })
        },
        buildTableData() {
            // construct table rows only when we have both base eligibilities
            if (!this.current_eligibility || !this.current_eligibility_pl) return;

            const propAmount = parseFloat(this.current_eligibility.max_eligibility || 0)
            const personalAmount = parseFloat((this.current_eligibility_pl && this.current_eligibility_pl.max_eligibility) || 0)

            const rows = [
                {
                    product: 'Property',
                    loan: propAmount,
                    status: propAmount > 0 ? 'Eligible' : 'Not Eligible',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_property,
                },
                {
                    product: 'Mortgage',
                    loan: propAmount,
                    status: propAmount > 0 ? 'Eligible' : 'Not Eligible',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mortgage,
                },
                {
                    product: 'Personal Loan',
                    loan: personalAmount,
                    status: personalAmount > 0 ? 'Eligible' : 'Not Eligible',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_personal_loan,
                },
                {
                    product: 'Insurance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_insurance,
                },
                {
                    product: 'Refinance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_refinance,
                },
                {
                    product: 'Other Loan',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_other_loan,
                },
                {
                    product: 'Solicitor',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_solicitor,
                },
                {
                    product: 'MHLV',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mhlv,
                }
            ]

            this.tableData = rows.filter((item) => !item.is_not_applicable)
            this.is_loading_table = false
            // if we have both eligibilities, recalc personal loan to take prefs into account
            if (this.current_eligibility && this.current_eligibility_pl) {
                this.refreshPersonalLoan()
            }
        },
        async refreshPersonalLoan() {
            // make sure we have PL data
            if (!this.current_eligibility_pl || !this.current_eligibility_pl.bank_eligibilities) return;
            let eligiblePL = 0
            const prefferedBanks = this.auth_user.subscription.scrb_banks || []
            if (prefferedBanks.length > 0) {
                prefferedBanks.forEach((bank) => {
                    this.current_eligibility_pl.bank_eligibilities.forEach((item) => {
                        if (item.bank_code === bank.bank_code) {
                            const loanAmt = parseFloat(item.bank_loan_eligibility_amount || 0)
                            const maxAmt = parseFloat(item.bank_max_loan_amount || 0)
                            if (loanAmt > eligiblePL) {
                                eligiblePL = loanAmt > maxAmt ? maxAmt : loanAmt
                            }
                        }
                    })
                })
            } else {
                this.current_eligibility_pl.bank_eligibilities.forEach((item) => {
                    const loanAmt = parseFloat(item.bank_loan_eligibility_amount || 0)
                    const maxAmt = parseFloat(item.bank_max_loan_amount || 0)
                    if (loanAmt > eligiblePL) {
                        eligiblePL = loanAmt > maxAmt ? maxAmt : loanAmt
                    }
                })
            }
            this.current_eligibility_pl.max_eligibility = eligiblePL
            if (!_gHlp.checkAccess(['c_customer__personal_loan_eligible'])) return;
            const plRow = this.tableData.find((item) => item.product === 'Personal Loan')
            if (plRow) {
                plRow.loan = eligiblePL
                plRow.status = eligiblePL > 0 ? 'Eligible' : 'Not Eligible'
            }
        },
        getPersonalLoanEligibilities() {
            axios.get(services.customer + 'customer/' + this.$route.params.customer_id + '/dsr.eligibilities?formula=PL', { headers: getHeader() })
                .then(res => {
                    this.personal_loan_bank_eligibilities = res.data.data.bank_eligibilities
                    this.personal_loan_bank_eligibilities.forEach((bank) => {
                        if (bank.bank_max_loan_amount > this.max_personal_loan_amount) {
                            this.max_personal_loan_amount = bank.bank_max_loan_amount
                        }
                    })
                    // avoid duplicating rows, rebuild table instead
                    this.buildTableData()
                })
                .catch(e => {
                    this.is_loading_table = false
                    this.errorFunction(e)
                })
        }
    }
}
</script>